// Simple in-memory cache with expiration
class CacheService {
  constructor() {
    this.cache = new Map();
    this.expirationTimes = new Map();
  }

  // Set cache with expiration (default 1 hour)
  set(key, value, expirationMinutes = 60) {
    const expirationTime = Date.now() + (expirationMinutes * 60 * 1000);
    this.cache.set(key, value);
    this.expirationTimes.set(key, expirationTime);
    
    // Clean up expired entries periodically
    this.cleanupExpired();
  }

  // Get from cache if not expired
  get(key) {
    if (!this.cache.has(key)) {
      return null;
    }

    const expirationTime = this.expirationTimes.get(key);
    if (Date.now() > expirationTime) {
      this.delete(key);
      return null;
    }

    return this.cache.get(key);
  }

  // Delete cache entry
  delete(key) {
    this.cache.delete(key);
    this.expirationTimes.delete(key);
  }

  // Clean up expired entries
  cleanupExpired() {
    const now = Date.now();
    for (const [key, expirationTime] of this.expirationTimes.entries()) {
      if (now > expirationTime) {
        this.delete(key);
      }
    }
  }

  // Generate cache key from search parameters
  static generateSearchKey(location, type, filters = {}) {
    const normalizedLocation = location.toLowerCase().trim();
    const filterString = Object.keys(filters)
      .sort()
      .map(key => `${key}:${filters[key]}`)
      .join('|');
    
    return `search:${normalizedLocation}:${type}:${filterString}`;
  }

  // Get cache statistics
  getStats() {
    return {
      totalEntries: this.cache.size,
      memoryUsage: JSON.stringify(Array.from(this.cache.entries())).length
    };
  }

  // Clear all cache
  clear() {
    this.cache.clear();
    this.expirationTimes.clear();
    console.log('All cache cleared');
  }
}

const cacheService = new CacheService();
export default cacheService;